import script from "./QuickSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickSearch.vue?vue&type=script&setup=true&lang=js"

import "./QuickSearch.vue?vue&type=style&index=0&id=032f05a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032f05a2"]])

export default __exports__